// extracted by mini-css-extract-plugin
export default {"BaseSettingsPage":"base-settings-page-module__BaseSettingsPage--xedrA"};